import { SchoolDetailsEffects } from './school-details.effect';
import { SchoolSearchResultsEffects } from './school-searchresults.effect';

export const effects: any[] = [SchoolSearchResultsEffects, SchoolDetailsEffects];

export * from './school-details.effect';
export * from './school-searchresults.effect';
